//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {mapGetters} from 'vuex';
import ImageBlock from 'components/blocks/Image.vue'
import TextLink from 'components/blocks/TextLink.vue'
import Animation from 'components/blocks/Animation.vue'
import ExpandableList from 'components/combinedBlocks/ExpandableList.vue'
import VideoFull from 'components/combinedBlocks/Video.vue'
import HeaderFull from 'components/combinedBlocks/HeaderFull.vue'
import FindSellerContact from 'components/combinedBlocks/FindSellerContact.vue'

export default {
  block: 'flexBlock',
  props: ['data'],
  data() {
    return {
      activeColumn: (this.startColumn) ? this.startColumn : 1,
      showColumn1: (this.data.header1 || this.data.text1 || this.data.img1 || this.data.component1) || ((this.data.columns == 1) || (this.data.columns == 2) || (this.data.columns == 3)),
      shrinkColumn1: !(this.data.header3 || this.data.text3 || this.data.img3 || this.data.component3) && (this.data.columns != 3),
      showColumn2: (this.data.header2 || this.data.text2 || this.data.img2 || this.data.component2) || ((this.data.columns == 3) || (this.data.columns == 2)),
      shrinkColumn3: !(this.data.header1 || this.data.text1 || this.data.img1 || this.data.component1) && (this.data.columns != 3),
      showColumn3: (this.data.header3 || this.data.text3 || this.data.img3 || this.data.component3 || this.data.columns == 3),
      growColumn1: !(this.data.header2 || this.data.text2 || this.data.img2 || this.data.component2) && this.data.columns == 3,
      growColumn2: !(this.data.header1 || this.data.text1 || this.data.img1 || this.data.component1) && !(this.data.header3 || this.data.text3 || this.data.img3 || this.data.component3) && this.data.columns == 3,
    }
  },
  components: {
    ImageBlock,
    TextLink,
    Animation,
    ExpandableList,
    VideoFull,
    HeaderFull,
    FindSellerContact,
  },
  computed: {
    ...mapGetters([
      'isMobile',
    ]),
    startColumn() {
      if (!this.data.mobile)
        return 1;

      return this.data.mobile.startColumn || 1;
    },
    columns() {
      return this.$el.getElementsByClassName(this.block+'-column');
    }
  },
  methods: {
    getVisibleColumn() {
      // Chosing visible column, and animating column only supported for mobile right now
      if (!this.isMobile)
        return this.startColumn;

      if (!this.data.mobile)
        return this.startColumn;

      if (!this.data.mobile.startColumn)
        return this.startColumn;

      if (!this.data.mobile.singleColumn)
        return this.startColumn;      

      // Set the first element
      const activeColumnElem = this.columns[this.activeColumn-1];
      activeColumnElem.style.display = 'flex';

      if (this.data.mobile.animate) {
        this.activeColumn = this.startColumn;
        return setInterval(() => {return this.animateColumns();}, 2000);
      } else {
        // Set the start column visible if not animating
        this.columns[this.startColumn-1].classList.add('m-visible');
        return this.data.mobile.startColumn;
      }
    },
    getBlockModifiers() {
      let bms = this.block;
      if (this.data.blockModifiers) {
        this.data.blockModifiers.forEach( (blockModifier, index) => {
          bms += ' bm-'+blockModifier;
        });
      }

      // Add singleColumn blockModifier if specified
      if (this.data.mobile != null)
        bms += (this.data.mobile.singleColumn) ? ' bm-singleMobileColumn' : '';

      return bms;
    },
    animateColumns() {
      const prevColumnElem = this.columns[this.activeColumn-1];

      prevColumnElem.classList.remove('m-visible');
      setTimeout( () => { 
        prevColumnElem.style.display = 'none';

        if (this.activeColumn < 3){
          this.activeColumn++;
        } else {
          this.activeColumn = 1;
        }

        // console.log("animate column: ", this.activeColumn, this.columns, this.columns[this.activeColumn]);
        const activeColumnElem = this.columns[this.activeColumn-1];
        activeColumnElem.style.display = 'flex';

        setTimeout( () => {
          activeColumnElem.classList.add('m-visible');
        }, 50);

      }, 500);

      return this.activeColumn;
    },
  },
  mounted() {
    this.getVisibleColumn();
  }
}



// WEBPACK FOOTER //
// ./components/globalBlocks/FlexBlock.vue